import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledMuiBreadcrumbs = (
  theme: Theme,
): BackstageOverrides['MuiBreadcrumbs'] => {
  const tokens = getThemeTokens(theme);

  return {
    root: {
      color: `${tokens.textSecondary} !important`,
      fontSize: theme.typography.body2.fontSize,
    },
    separator: {
      color: `${tokens.textMuted} !important`,
    },
  };
};
